export default "__VITE_ASSET__Bw$HiqDz__"